import React, { useEffect, useRef, useState } from 'react';

/**
 * Embeds the Luma calendar widget and resizes the iframe to fit its content
 * by listening for Luma's postMessage resize events. Falls back to a
 * reasonable min-height if no message is received.
 */
const LumaCalendarEmbed = ({ src, title = 'Events Calendar', initialHeight = 480 }) => {
  const iframeRef = useRef(null);
  // Tight default sized to current event count; resize message will adjust
  // automatically if Luma starts sending one in the future.
  const [height, setHeight] = useState(initialHeight);

  useEffect(() => {
    const onMessage = (event) => {
      // Luma posts messages from its own origin.
      if (!event.origin?.includes('luma.com')) return;
      // Luma sends shapes like { type: 'iframe-content-resize', height: 1234 }
      // and sometimes a JSON string with similar payload.
      let data = event.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (_) {
          return;
        }
      }
      if (
        data &&
        (data.type === 'iframe-content-resize' || data.type === 'resize') &&
        typeof data.height === 'number' &&
        data.height > 0
      ) {
        setHeight(Math.max(360, Math.min(data.height, 1600)));
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  return (
    <iframe
      ref={iframeRef}
      src={src}
      title={title}
      className="w-full block"
      style={{ height: `${height}px`, border: 'none' }}
      frameBorder="0"
      allowFullScreen
      aria-hidden="false"
      tabIndex={0}
      loading="lazy"
    />
  );
};

export default LumaCalendarEmbed;
